import React from 'react';
import { agentMayShowDocument } from '../shared/documentFolders';

/**
 * What an agent sees of a homeowner's files.
 * The list is already limited by RLS. This hides a row only when the
 * payload explicitly says it was not shared.
 */
export default function AgentSharedDocuments({ documents, colors, onOpen }) {
  const visible = (Array.isArray(documents) ? documents : []).filter(agentMayShowDocument);
  const ink = colors || {};
  const text = ink.text || '#111';
  const muted = ink.textSecondary || '#6b7280';
  const surface = ink.surface || '#fff';
  const border = ink.border || '#e5e7eb';

  return (
    <section aria-label="Documents shared with you" data-screen="agent">
      <h3 style={{ margin: '0 0 0.35rem', fontSize: '1rem', color: text }}>Documents shared with you</h3>
      <p style={{ margin: '0 0 0.85rem', color: muted, fontSize: '0.9rem' }}>
        Only documents this homeowner shared.
      </p>
      {visible.length === 0 ? (
        <p style={{ margin: 0, color: muted }}>Nothing shared yet.</p>
      ) : (
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '0.65rem' }}>
          {visible.map((doc) => (
            <li
              key={doc.id || doc.title}
              style={{
                background: surface,
                border: `1px solid ${border}`,
                borderRadius: 12,
                padding: '0.85rem 0.95rem',
              }}
            >
              <div style={{ fontWeight: 600, color: text, wordBreak: 'break-word' }}>{doc.title}</div>
              {doc.category ? (
                <div style={{ marginTop: '0.2rem', color: muted, fontSize: '0.9rem' }}>{doc.category}</div>
              ) : null}
              {doc.file_path && onOpen ? (
                <button
                  type="button"
                  onClick={() => onOpen(doc)}
                  style={{
                    marginTop: '0.65rem',
                    minHeight: 44,
                    padding: '0.45rem 0.9rem',
                    borderRadius: 10,
                    border: `1px solid ${ink.primary || '#59c4c4'}`,
                    background: 'transparent',
                    color: ink.primary || '#0f766e',
                    fontWeight: 600,
                    fontFamily: 'inherit',
                  }}
                >
                  Open
                </button>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
